import React from "react";
import { Link } from "react-router-dom";
import { getAllProjects } from "../../lib/loadContent";

const ASCII = `
██████╗  ██████╗ ██████╗ ████████╗███████╗ ██████╗ ██╗     ██╗ ██████╗ 
██╔══██╗██╔═══██╗██╔══██╗╚══██╔══╝██╔════╝██╔═══██╗██║     ██║██╔═══██╗
██████╔╝██║   ██║██████╔╝   ██║   █████╗  ██║   ██║██║     ██║██║   ██║
██╔═══╝ ██║   ██║██╔══██╗   ██║   ██╔══╝  ██║   ██║██║     ██║██║   ██║
██║     ╚██████╔╝██║  ██║   ██║   ██║     ╚██████╔╝███████╗██║╚██████╔╝
╚═╝      ╚═════╝ ╚═╝  ╚═╝   ╚═╝   ╚═╝      ╚═════╝ ╚══════╝╚═╝ ╚═════╝`;

const QUICK_LINKS = [
  { to: "/about", label: "about" },
  { to: "/projects", label: "projects" },
  { to: "/experience", label: "work" },
  { to: "/resume", label: "resume" },
  { to: "/contact", label: "contact" },
];

const Dashboard = () => {
  const projects = getAllProjects();

  return (
    <div className="page dashboard">
      <pre className="ascii-logo">{ASCII}</pre>

      <p className="dashboard-intro">
        Hi, I&apos;m <span className="accent">DogeTheBeast</span>. I build
        developer tooling, automation systems and open-source projects.
      </p>

      <nav className="quick-links" aria-label="Quick navigation">
        {QUICK_LINKS.map((l) => (
          <Link key={l.to} to={l.to} className="quick-link">
            {l.label}
          </Link>
        ))}
      </nav>

      <div className="dashboard-grid">
        <section className="panel">
          <h2 className="panel-title">current focus</h2>

          <ul className="panel-list">
            <li>
              Recreating <code>git</code> in Rust 🦀 with an extensive testsuite
            </li>
            <li>
              Experimenting with the best method to integrate AI into my
              workflow
            </li>
          </ul>
        </section>

        <section className="panel">
          <h2 className="panel-title">recent projects</h2>
          <ul className="panel-list">
            {projects.slice(0, 3).map((p) => (
              <li key={p.slug}>
                <Link to={`/projects/${p.slug}`}>{p.title}</Link>
                <span className="panel-desc">{p.tagline}</span>
              </li>
            ))}
          </ul>
        </section>
      </div>
    </div>
  );
};

export default Dashboard;
